/* eslint-disable import/no-cycle */
import { mrpSwitchesDefault } from './mrpSwitchesDefault';
import {
  assoSwitchesDefaultRc,
  assoSwitchesDefaultLocal
} from './assoSwitchDefault';
import useAuthContext from '../../contexts/AuthContext';
import {
  TURNOVER_DEFAULT_VALUE as TURNOVER_DO_DEFAULT_VALUE,
  GUARANTEE_LIMIT_DEFAULT_VALUE as GUARANTEE_LIMIT_DO_DEFAULT_VALUE
} from './doFields';
import {
  RCPMK_DEDUCTIBLE_AMOUNT_DEFAULT_VALUE,
  RCPMK_GUARANTEE_LIMIT_DEFAULT_VALUE,
  RCPMK_TURNOVER_DEFAULT_VALUE
} from './rcpmkFields';
import {
  MRIWK_BUILDING_COUNT_DEFAULT_VALUE,
  MRIWK_BUILDING_QUALITY_DEFAULT_VALUE,
  MRIWK_BUILDING_TYPES_DEFAULT_VALUE,
  MRIWK_DEDUCTIBLE_AMOUNT_RATIO_DEFAULT_VALUE,
  MRIWK_FURNITURE_GUARANTEE_DEFAULT_VALUE,
  MRIWK_GUARANTEE_PACKAGE_DEFAULT_VALUE,
  MRIWK_IGH_IGS_VALUES_DEFAULT_VALUE,
  MRIWK_OFFICE_ACTIVITY_PERCENTAGE_DEFAULT_VALUE,
  MRIWK_OPTIONNAL_GUARANTEES_DEFAULT_VALUE,
  MRIWK_OUTBUILDING_SURFACE_DEFAULT_VALUE,
  MRIWK_PROPERTY_ALTITUDE_DEFAULT_VALUE,
  MRIWK_PROPERTY_MANAGER_DEFAULT_VALUE,
  MRIWK_PROPERTY_NATURE_DEFAULT_VALUE,
  MRIWK_SHOP_ACTIVITY_PERCENTAGE_DEFAULT_VALUE,
  MRIWK_SURFACE_DEFAULT_VALUE,
  MRIWK_VACANT_AREA_DEFAULT_VALUE,
  MRIWK_DEADLINE_BEFORE_RENTAL_DEFAULT_VALUE,
  MRIWK_VACANT_REASON_DEFAULT_VALUE,
  MRIWK_WOOD_FLOOR_DEFAULT_VALUE
} from './mriwkFields';

const useDefaultValues = ({
  type,
  mrpType = 'any',
  assoType = 'localRC',
  supplier
}) => {
  const { getProductAccess } = useAuthContext();

  const defaultValues = {
    rcp: {
      answerDelay: 'HIGH',
      turnover: 0,
      legal_protection: supplier === 'wk',
      guarantee_limit: supplier === 'wk' || supplier === 'cm' ? 150000 : 50000,
      legal_protection_choice: 0,
      deductible_amount: supplier === 'wk' ? 750 : 1730,
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      number_claims: 0,
      payment_type: 'DIRECTDEBIT',
      paperwork_fee: 0,
      company_been_insured: false,
      termination_by_company: false,
      company_in_creation: supplier !== 'ml',
      surface_area: 0,
      fraction_type: 'MONTHLY',
      industrial_activity: false,
      straw_rubber_activity: false,
      metropolitan_france: true,
      religious_pol: false,
      employees_number: 0,
      sworn_statement: true,
      mobility_guarantee: 0,
      industrial_straw_activity: false,
      construction_activity: false,
      medical_activity: false,
      is_in_liquidation_or_receivership: false,
      legal_activity: false,
      has_already_been_terminated_by_asx: false,
      key_man_guarantee: false,
      france_with_corsica: true,
      exploitation_responsibility: false
    },
    rcngawk: {
      answerDelay: 'HIGH',
      turnover: 250000,
      legal_protection: true,
      extended_legal_protection: false,
      company_status: 'AUTO_ENTREPRENEUR',
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      number_claims: 0,
      payment_type: 'DIRECTDEBIT',
      paperwork_fee: 0,
      company_been_insured: false,
      termination_by_company: false,
      fraction_type: 'YEARLY',
      guarantee_package: 'PKG_1',
      w_garage_certificate: [],
      w_garage_certificate_number: 0,
      // prerequisites
      withdrawal_drivin_license: false,
      liquidation_property_or_legal_recovery: false,
      guaranteed_liability_involved: false,
      more_than_two_claims: false,
      compliant_installations: false,
      bodily_claim: false,
      driving_while_intoxicated: false,
      political_person_exposed: false,
      glass_breakage_guarantee: false,
      hail_guarantee: false,
      activity: 'Négociant Automobiles / Mandataire',
      max_fleet_size: 'MAX_50',
      vehicle_value_range: 'STANDARD',
      entrusted_vehicles: 'MAX_3'
    },
    rcpmk: {
      //  COMPANY ACTIVITY
      is_startup: true,
      activity_type: 'IT',
      service_activity_details: [],

      //  PRICING
      turnover: RCPMK_TURNOVER_DEFAULT_VALUE,
      guarantee_limit: RCPMK_GUARANTEE_LIMIT_DEFAULT_VALUE,
      deductible_amount: RCPMK_DEDUCTIBLE_AMOUNT_DEFAULT_VALUE,

      //  ADDITIONNAL GUARANTEE
      operational_protection: false,
      cyber_events_protection: false,
      key_man_protection: false,
      merge_protection: false,
      management_protection: false,

      //  PREREQUISITES
      it_forbidden_activities: true,
      it_regulated_activities: true,
      media_forbidden_activities: true,
      service_forbidden_activities_one: true,
      service_forbidden_activities_two: true,
      service_forbidden_activities_three: true,
      consulting_forbidden_activities: true,
      managment_protection_prerequisite: true,
      cyber_protection_prerequisite: true,
      merge_protection_prerequisite: true,
      etablishment_outside_france: true,
      limited_turnover_in_usa: true,
      limited_claims_indemnity: true,
      current_claim: true,

      //  INSURANCE HISTORY
      sworn_statement: true,
      company_in_creation: false,

      //  BROKER FEES
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,

      //  PAYMENT
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT'
    },
    rcphx: {
      activity_type: 'TECH',
      activity_detail: [],
      turnover: 0,
      turnover_usa_canada: false,
      turnover_usa_canada_amount: 0,
      turnover_usa_canada_type: 'CURRENCY',
      guarantee_limit: 100000,
      legal_protection_rcphx: true,
      legal_protection_rcphx_extended: false,

      exploitation_responsibility: false,
      //  PAYMENT
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT',
      //  BROKER FEES
      commission_fee: 12.5,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,

      // PREREQUISITES
      geographic_exposure_hiscox: false,
      geographic_exposure_hiscox_world: false,
      insurance_historic_hiscox: false,
      activity_hiscox_tech: false,
      activity_hiscox_mac: false,
      activity_hiscox_mac_world: false,
      activity_hiscox_man: false,
      activity_hiscox_man_world: false,
      activity_hiscox_med: false,
      activity_hiscox_med_world: false,
      activity_hiscox_misc: false,
      activity_transport_misc: false,
      activity_borloo_misc: false,
      activity_hiscox_misc_tattoo: false,
      compliance_hiscox_misc_tattoo: false,
      activity_hiscox_tech_ia: false,
      activity_hiscox_bie: false,
      activity_hiscox_bie_pregnants: false,
      activity_hiscox_bie_pregnants_manipulation: false,
      activity_hiscox_bie_children: false,
      activity_hiscox_med_paramedical: false,
      activity_hiscox_osteo: false,
      cyber_option_rcphx: false,
      cyber_option_rcphx_extended: false,
      cyber_option_rcphx_fraud: false,
      activity_hiscox_cyber: false,
      history_cyber_hiscox: false,
      geographic_exposure_hiscox_cyber: false,
      history_risk_hiscox: false
    },
    rcgls: {
      turnover: 0,
      main_activity: 'ACI',
      guarantee_limit: 250000,
      sworn_statement: true,
      //  ADDITIONNAL GUARANTEE
      insurance_brokers: false,
      operational_liability: true,
      iobsp_broker_errors: false,
      iobsp_exclusive_agent_errors: false,
      iobsp_non_exclusive_agent_errors: false,
      iobsp_mandate_professional: false,
      banking_solicitor_errors: false,
      investment_advisor_errors: false,
      insurance_intermediary_guarantee: false,
      real_estate_transaction_errors: true,
      general_agents_and_brokers_errors: false,
      insurance_sub_agents_errors: false,
      real_estate_transaction_guarantee: false,
      wealth_and_financial_advisor_errors: false,
      banking_and_finance_intermediary_professional: false,
      borrower_insurance_intermediary_errors: false,
      iobsp_broker_guarantee: false,

      //  COMMON PREREQUISITES
      no_activity_usa_canada: true,
      not_listed_in_eu_sanctions: true,
      accurate_and_truthful_declarations: true,
      report_change_of_situation: true,
      no_acpr_sanctions: true,
      no_foreign_branch_or_subsidiary: true,
      no_problems_last_5_years: true,
      no_known_risk_facts: true,
      orias_required_for_guarantee: true,
      registration_required_for_guarantee: true,
      already_resiliated_by_assurmax: false,
      politically_exposed_person: false,
      legal_and_regulatory_compliance: true,

      // ACI PREREQUISITES
      multiple_principals: true,
      registered_commercial_agent: true,
      professional_card_number: undefined,
      in_process_cci: true,
      issuing_chamber: undefined,
      agency_contact_details: undefined,
      // CGP_CIF PREREQUISITES
      no_financial_engineering: true,
      real_estate_tax_reduction_activity: true,
      no_asset_management_for_third_parties: true,
      no_miscellaneous_goods_intermediation: true,
      no_gestion_patrimoine_without_cif: true,
      // IO_BSP PREREQUISITES
      mandataires_to_cover: false,
      orias_compliance_insurance: true,
      accessory_activity_ia_mia_dfb: false,
      orias_number: '',
      accessory_activity_ia_mia: false,
      accessory_activity_dfb: false,

      delegation_or_mandate: false,
      wants_financial_guarantee: false,
      accounts_verified_by_accountant: true,
      mandataires_to_cover_mias: false,
      no_risky_insurance_contexts: true,
      reinsurance_broker: false,
      orias_compliance_assurance: true,
      accessory_activity_iobsp_dfb_cif: false,
      accessory_activity_iobsp: false,
      accessory_activity_dfb_again: false,
      accessory_activity_cif: false,

      no_foreign_branch: true,
      no_property_management_activity: true,
      real_estate_tax_reduction_activity_ai: false,
      wants_financial_guarantee_no_funds: false,
      accessory_activity_ia_mia_or_iobsp_miobsp: false,
      accessory_activity_ia_mia_alt: false,
      accessory_activity_iobsp_miobsp: false,

      single_mandate_insurance: true,
      single_mandate_iobsp: true,
      mandant_details: '',
      orias_compliance_miobsp: true,
      orias_compliance_bank: true,
      risky_mandant_relationships: false,
      maritime_insurance: false,
      construction_insurance: false,
      construction_insurance_company_check: true,
      construction_project_check: false,
      only_france_based_clients: true,
      no_us_canada_bank_activity: true,

      //  INSURANCE HISTORY
      company_in_creation: false,

      //  BROKER FEES
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,

      //  PAYMENT
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT'
    },
    association: {
      answerDelay: 'HIGH',
      turnover: 0,
      legal_protection: true,
      civil_responsibility_asso: assoType === 'rc',
      local_insurance: assoType !== 'rc',
      local: assoType !== 'rc',
      guarantee_limit: 100000,
      deductible_amount: 500,
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      number_claims: 0,
      payment_type: 'DIRECTDEBIT',
      paperwork_fee: 0,
      company_been_insured: false,
      termination_by_company: false,
      surface_area: 0,
      fraction_type: 'MONTHLY',
      employees_number: 0,
      representatives_number: 0,
      total_members: 0,
      yearly_events: '0',
      participants_per_event: 'MAXIMUM_200',
      sworn_statement: true,
      protection_level: 1,
      closed_more_60_days: false,
      litigation_responsibility: false,
      blocked_activities: false,
      mall: false,
      max_claims: false,
      no_claims: false,
      confirm_claims: true,
      had_waived_certain_remedies_in_its_lease: false,
      metropolitan_france: true,
      annual_budget: false,
      is_a_palace: false,
      monument: false,
      embassy_bowling_disco: false,
      industry_less_10m: false,
      political_activity: false,
      built_covered_hard_materials: true,
      close_help: true,
      altitude_location: true,
      renovation: false,
      disaffected: false,
      zone_ind_com_art: false,
      take_care_building: true,
      extinguisher_conformed: true,
      electric_conformed: true,
      restaurant_activity: true,
      close_before_2300: true,
      chilled_products_conformed: true,
      malj_member: false,
      package: 'PACKAGE_1',
      PACKAGE_1: {
        fire_explosion_attack_climatic_event: assoType !== 'rc' ? 10000 : 0,
        theft_vandalism: assoType !== 'rc' ? 5000 : 0,
        water_damage: assoType !== 'rc' ? 5000 : 0,
        broken_windows: assoType !== 'rc' ? 2000 : 0,
        electric_damage: assoType !== 'rc' ? 5000 : 0,
        ...(assoType !== 'rc'
          ? { ...assoSwitchesDefaultLocal }
          : { ...assoSwitchesDefaultRc })
      }
    },
    mrp: {
      legal_protection_choice: 0,
      company_been_insured: false,
      sworn_statement: true,
      employees_number: 0,
      turnover: 0,
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      number_claims: 0,
      payment_type: 'DIRECTDEBIT',
      paperwork_fee: 0,
      termination_by_company: false,
      company_in_creation: true,
      deductible_amount: supplier === 'wk' ? 750 : 830,
      exploitation_responsibility: false,
      surface_area: 0,
      protection_level: 1,
      fraction_type: 'MONTHLY',
      closed_more_60_days: false,
      mall: false,
      mall_big: false,
      '75percent_tough_materials': true,
      '90percent_tough_materials': true,
      take_care_building: true,
      '2_incidents_max': true,
      more_500m_altitude: true,
      close_help: true,
      castle_manor: false,
      castle: false,
      redress_liquidation: true,
      wooden_construction: true,
      temporary_activity: true,
      monument: false,
      specific1_activities: true,
      specific2_activities: true,
      metropolitan_france: true,
      localized_qpv: false,
      lci_sufficient: true,
      half_timbering_structure: false,
      extinguisher_conformed: true,
      electric_conformed: true,
      restaurant_activity: true,
      close_before_2300: true,
      chilled_products_conformed: true,
      waiver_of_recourse_clause: false,
      market_value: 0,
      business_loss_guarantee: 0,
      is_in_liquidation_or_receivership: false,
      mobility_guarantee: 0,
      rc_pro: false,
      rc_pro_guarantee: 0,
      activities: mrpType === 'office' ? ['Activité de bureau'] : undefined,
      furniture_capital: 10000,
      package: 'PACKAGE_1',
      PACKAGE_1: {
        fire_explosion_attack_climatic_event: 10000,
        theft_vandalism: supplier === 'ml' ? 3333 : 2500,
        water_damage: supplier === 'ml' ? 3333 : 2500,
        broken_windows: 1000,
        broken_machine: 1000,
        electric_damage: 1000,
        external_furniture: 0,
        chilled_merchandise: 0,
        ...mrpSwitchesDefault,
        ...(supplier === 'ml'
          ? {
              assistance: true,
              legal_protection_mrp: false,
              archives_capital: true,
              value_capital: true,
              art_capital: true,
              theft_capital: true,
              object_of_value: true,
              lent_goods: true
            }
          : {})
      },
      PACKAGE_2: {
        fire_explosion_attack_climatic_event: 10000,
        theft_vandalism: 5000,
        water_damage: 5000,
        broken_windows: 2000,
        broken_machine: 2000,
        electric_damage: 2000,
        external_furniture: 0,
        chilled_merchandise: 0,
        ...mrpSwitchesDefault,
        ...(supplier === 'ml'
          ? {
              assistance: true,
              legal_protection_mrp: false,
              archives_capital: true,
              value_capital: true,
              art_capital: true,
              theft_capital: true,
              object_of_value: true,
              lent_goods: true
            }
          : {})
      },
      PACKAGE_3: {
        fire_explosion_attack_climatic_event: 10000,
        theft_vandalism: 10000,
        water_damage: 10000,
        broken_windows: 4000,
        broken_machine: 4000,
        electric_damage: 4000,
        external_furniture: 2000,
        chilled_merchandise: 2000,
        ...mrpSwitchesDefault,
        ...(supplier === 'ml'
          ? {
              assistance: true,
              legal_protection_mrp: false,
              archives_capital: true,
              value_capital: true,
              art_capital: true,
              theft_capital: true,
              object_of_value: true,
              lent_goods: true
            }
          : {})
      }
    },
    mriml: {
      sworn_statement: true,
      attack_tax: 6.5,
      subscriber: 'LEGAL_ENTITY',
      subscriber_type: 'LE_NOO_REAL_ESTATE_COMPANY',
      surface_area: 0,
      building_situation: 'CO_OWNERSHIP',
      total_buildings: 1,
      absence_concrete_floor: false,
      deductible_cost_index: '1x',
      guarantee_type: 'TYPE1',
      commission_fee: 0,
      broker_fee: 0,
      main_use: 'rec_DWELLING',
      contribution_adjustment: 0,
      paperwork_fee: 0,
      legal_protection: false,
      extended_legal_protection: false,
      is_continuously_insured_since_acquisition: true,
      information_statements_submission_date: true,
      fire_claim_last_60_months_subscriber_affiliates: false,
      contains_asbestos_or_fibrocement: false,
      roof_contains_non_standard_materials: false,
      risk_has_graffitis_or_tags: false,
      roof_non_standard_materials: false,
      is_property_dealer: false,
      rc_volunteer_union: false,
      risk_typology: 'STANDARD',
      occupation_trade: 'under_25',
      number_claims: 0,
      is_lci_of_x_million_sufficient: true,
      fraction_type: 'MONTHLY',
      selected_options: [],
      payment_type: 'DIRECTDEBIT',
      buildings: [{ building_name: ' ', building_siret: ' ' }],
      number_activity: 1
    },
    pnoml: {
      attack_tax: 6.5,
      subscriber: 'LEGAL_PERSON',
      subscriber_type: 'LP_NOO_NON_OCCUPANT_OWNER',
      main_use: 'rec_APPARTMENT',
      surface_area: 0,
      total_buildings: 1,
      deductible_cost_index: '0,5x',
      guarantee_type: 'TYPE1',
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,
      legal_protection: false,
      number_claims: 0,
      fraction_type: 'YEARLY',
      payment_type: 'CARD',
      buildings: [{ building_name: ' ', building_siret: ' ' }],
      number_activity: 1,
      tenant_in_restructuring_or_liquidation: false,
      property_under_construction_prerequisite: false,
      no_prohibited_activities_declared: false,
      property_in_renovation_over_4_months: false,
      property_in_historic_building: false,
      property_in_castle_or_listed_building: false,
      risk_has_prohibited_restaurant_activities: false,
      risk_has_industrial_activities: false,
      is_property_occupied_or_will_be_within_2_months: true,
      property_previously_insured: true,
      have_you_owned_property_for_more_than_2_months: false
    },
    mri: {
      sworn_statement: true,
      attack_tax: 6.5,
      subscriber: 'LEGAL_PERSON',
      subscriber_type: 'LP_NOO_NON_OCCUPANT_OWNER',
      building_type: 'NOOFGPRICING1_RENTAL_BUILDING',
      surface_area: 0,
      total_buildings: 1,
      concrete_floor: true,
      deductible_cost_index: '1x',
      guarantee_type: 'TYPE1',
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,
      hard_materials: true,
      risk_typology: 'UNFURNISHED',
      occupation_trade: 'under_25',
      number_claims: 0,
      good_state: true,
      altitude_location: true,
      accessibility: true,
      metropolitan_france: true,
      activity_open_public: true,
      contractual_general_indemnity_limit: true,
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT',
      buildings: [{ building_name: ' ', building_siret: ' ' }],
      number_activity: 1
    },
    prevoyance: {
      sworn_statement: true,
      customer_type: 'INDIVIDUAL',
      package: 'SOLO',
      period: 'PRIVATE',
      capital: 10000,
      death: true,
      disability: true,
      lawsuit: true,
      recipient_clause: 'STANDARD',
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT',
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0
    },
    do: {
      // PRICING
      turnover: TURNOVER_DO_DEFAULT_VALUE,
      guarantee_limit: GUARANTEE_LIMIT_DO_DEFAULT_VALUE,
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT',
      company_in_creation: false,

      // PREREQUISITES
      max_tax_result: true,
      metropolitan_france: true,
      more_than_2_years: true,
      no_merge_takeover: true,
      stock_exchange_listing: true,
      insolvency_proceeding: true,
      not_operate_in_forbidden_activities: true,
      positive_last_2_tax_result: true,
      positive_last_2_equity: true,
      last_5_years_blame: true,
      holding_prerequisites: true,

      // ADDITIONAL GUARANTEE
      employer_protection: false,
      cyber_protection: false,
      holding_protection: false,
      key_person_protection: false,

      // BROKER FEES
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,

      sworn_statement: true
    },
    mriwk: {
      // PRICING
      address: {
        number: ''
      },
      property_name: '',
      property_siret: '',
      building_count: MRIWK_BUILDING_COUNT_DEFAULT_VALUE,
      building_type: MRIWK_BUILDING_TYPES_DEFAULT_VALUE,
      building_type_other: '',
      building_quality: MRIWK_BUILDING_QUALITY_DEFAULT_VALUE,
      property_nature: MRIWK_PROPERTY_NATURE_DEFAULT_VALUE,
      surface_area: MRIWK_SURFACE_DEFAULT_VALUE,

      igh_igs: MRIWK_IGH_IGS_VALUES_DEFAULT_VALUE,
      property_altitude: MRIWK_PROPERTY_ALTITUDE_DEFAULT_VALUE,
      property_managers: MRIWK_PROPERTY_MANAGER_DEFAULT_VALUE,
      wood_floor: MRIWK_WOOD_FLOOR_DEFAULT_VALUE,

      is_condominium: true,
      is_vacant: false,
      vacant_reason: MRIWK_VACANT_REASON_DEFAULT_VALUE,
      vacant_area: MRIWK_VACANT_AREA_DEFAULT_VALUE,
      deadline_before_rental: MRIWK_DEADLINE_BEFORE_RENTAL_DEFAULT_VALUE,
      contains_professional_activity: false,
      office_activity_percentage:
        MRIWK_OFFICE_ACTIVITY_PERCENTAGE_DEFAULT_VALUE,
      shop_activity_percentage: MRIWK_SHOP_ACTIVITY_PERCENTAGE_DEFAULT_VALUE,
      contains_outbuilding: false,
      outbuilding_surface: MRIWK_OUTBUILDING_SURFACE_DEFAULT_VALUE,
      is_furnished: 'NO',
      other_furnished: '',
      furniture_guarantee: MRIWK_FURNITURE_GUARANTEE_DEFAULT_VALUE,
      company_been_insured: false,
      termination_by_company: false,
      number_claims: 0,
      fraction_type: 'MONTHLY',
      payment_type: 'DIRECTDEBIT',

      optionnal_guarantees: MRIWK_OPTIONNAL_GUARANTEES_DEFAULT_VALUE,
      legal_protection: true,
      deductible_amount_ratio: MRIWK_DEDUCTIBLE_AMOUNT_RATIO_DEFAULT_VALUE,
      guarantee_package: MRIWK_GUARANTEE_PACKAGE_DEFAULT_VALUE,

      // PREREQUISITES
      hard_material_prerequisite: true,
      good_state_prerequisite: true,
      firefighting_water_prerequisite: true,
      rescue_access_prerequisite: true,
      metropolitan_france_prerequisite: true,
      public_late_prerequisite: true,
      actually_rented_prerequisite: true,
      is_asl_aful_prerequisite: false,
      fast_food_prerequisite: false,
      classified_prerequisite: false,
      monument_prerequisite: false,
      liquidation_prerequisite: false,
      wood_construction_prerequisite: false,
      wood_full_risk_prerequisite: false,
      temporary_activity_prerequisite: false,
      recreation_activity_prerequisite: false,
      political_activity_prerequisite: false,
      near_industrial_activity_prerequisite: false,
      industrial_activity_prerequisite: false,
      transformed_products_prerequisite: false,
      waiver_clause_prerequisite: false,
      cold_room_prerequisite: false,
      unbuildable_prerequisite: false,
      tall_building_prerequisite: false,
      roof_prerequisite: false,
      agricultural_building_prerequisite: false,
      igh_igs_prerequisite: false,
      wood_floor_prerequisite: false,
      peril_prerequisite: false,
      vacant_prequisite: false,
      demolition_prerequisite: false,
      zup_prerequisite: false,
      flooding_prerequisite: false,
      condominium_surface_prerequisite: false,

      // BROKER FEES
      commission_fee: 0,
      broker_fee: 0,
      contribution_adjustment: 0,
      paperwork_fee: 0,

      sworn_statement: true
    }
  };

  const p = defaultValues[type];
  const pro = getProductAccess(type);
  if (pro) {
    if (pro.advancedManagement?.blocked_fit?.selected) {
      p.commission_fee = pro.advancedManagement.blocked_fit.commission_rate;
      p.broker_fee = pro.advancedManagement.blocked_fit.brokerage_fees;
      p.paperwork_fee = pro.advancedManagement.blocked_fit.administration_fees;
    }
    if (pro.advancedManagement?.controlled_fit?.selected) {
      p.commission_fee =
        pro.advancedManagement.controlled_fit.commission_rate_minVal;
      p.broker_fee =
        pro.advancedManagement.controlled_fit.brokerage_fees_minVal;
      p.paperwork_fee =
        pro.advancedManagement.controlled_fit.administration_fees_minVal;
    }
  }
  return p;
};

export default useDefaultValues;
